import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Dialog, Fade, StyledEngineProvider, ThemeProvider, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import AcquiringDashboardViewTable from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/AcquiringChargesViewModalTable'
import { newFormThemeOverrides } from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/styles'
import { finishErrorAlert } from 'redux/alert/alert-actions'
import { useAppSelector } from 'redux/hooks'
import { themeStyles, useTheme } from 'themes'

interface IProps {
    classes: Record<string, string>
    children: React.ReactNode
    charge: ChargesRecord
}

const AcquiringChargesView: React.FC<IProps> = ({ classes, children, charge }) => {
    const dispatch = useDispatch()
    const { errorAlert } = useAppSelector(state => state.alert)
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })

    const [open, setOpen] = React.useState(false)

    useEffect(() => {
        if (errorAlert) {
            dispatch(finishErrorAlert())
        }
    }, [open])

    const handleOpen = () => setOpen(true)

    const handleClose = () => setOpen(false)

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={formTheme}>
                <Typography component="div" onClick={handleOpen} style={{ width: '100%', height: '100%' }}>
                    {children}
                </Typography>
                <Dialog
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    classes={{ paper: classes.paperDialogWidth, container: classes.MuiDialogContainer }}
                >
                    <Fade in={open}>
                        <div className={classes.paperDialog}>
                            <AcquiringDashboardViewTable charge={charge} handleClose={handleClose} />
                        </div>
                    </Fade>
                </Dialog>
            </ThemeProvider>
        </StyledEngineProvider>
    )
}

export default withStyles(themeStyles.useModalStyles)(AcquiringChargesView)
